import { TwcProduct } from '../../../twc-products';
import { TWC_GOVERNMENT_SIGMETS_VECTOR_STYLE } from './government-sigmets.vector-style';

export const GOVERNMENT_SIGMETS_PRODUCT_DATA: TwcProduct = {
  id: 'government-sigmets',
  defaultProductId: '6003-boeing',
  productName: 'Weather-GOV-SIGMETS-TWC',
  label: 'Government Sigmets',
  weatherType: 'SIGMET',
  description: 'TWC product (vector) - Government SIGMETs',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 0,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: TWC_GOVERNMENT_SIGMETS_VECTOR_STYLE }
  }
};
